module.exports = __webpack_public_path__ + "img/1697740098487.79bfe3b9.jpg";